<template>
	<v-menu
		v-model="menu"
		top
		nudge-bottom="80"
		nudge-left="16"
		:close-on-content-click="false"
		max-width="269"
	>
		<template v-slot:activator="{ on }">
			<v-text-field
				:value="color"
				:label="label"
				:clearable="clearable"
				readonly
				:error-count="3"
				:error-messages="errors"
				v-on="on"
				@click:clear="onInput(null)"
			>
				<template v-slot:prepend>
					<div :style="swatchStyle" v-on="on" />
				</template>
			</v-text-field>
		</template>
		<v-color-picker
			:value="color"
			:mode="mode"
			:hide-mode-switch="hideModeSwitch"
			@input="onInput"
		/>
	</v-menu>
</template>

<script>
export default {
	props: {
		mode: {
			type: String,
			default: 'hexa',
		},
		alpha: {
			type: Boolean,
			default: false,
		},
		hideModeSwitch: {
			type: Boolean,
			default: true,
		},
		value: {
			type: String,
		},
		label: {
			type: String,
		},
		clearable: {
			type: Boolean,
			default: false,
		},
		errors: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			color: '#000000',
			mask: '!#XXXXXX',
			menu: false,
		}
	},
	mounted() {
		if (!this.value || this.value === '') {
			this.color = `#000000${this.alpha ? '00' : ''}`
		} else {
			this.color = this.value
		}
	},
	computed: {
		swatchStyle() {
			const { color, menu } = this
			return {
				backgroundColor: color,
				cursor: 'pointer',
				height: '30px',
				width: '30px',
				borderRadius: menu ? '50%' : '4px',
				transition: 'border-radius 200ms ease-in-out',
			}
		},
	},
	watch: {
		value() {
			if (this.value && this.value !== this.color) {
				this.color = this.value
			}
		},
	},
	methods: {
		onInput(event) {
			this.color = event
			this.$emit('input', event)
		},
	},
}
</script>
